import { render, staticRenderFns } from "./ViewerPanelViews.vue?vue&type=template&id=36326474&scoped=true"
import script from "./ViewerPanelViews.vue?vue&type=script&lang=js"
export * from "./ViewerPanelViews.vue?vue&type=script&lang=js"
import style0 from "./ViewerPanelViews.vue?vue&type=style&index=0&id=36326474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36326474",
  null
  
)

export default component.exports